import React from 'react';
import {Container, Table} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import {flexRender, getCoreRowModel, useReactTable} from '@tanstack/react-table';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faFileLines} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import '../vip/Pagination.css'
import ApiService from "../../api/ApiService";
import { formatBeijingTime } from "../../api/TimeService";


const columns = [
    {
        accessorKey: 'amount',
        header: '佣金变化',
        Cell: ({cell}) => (
            <span style={{color: 'white', fontSize: '16px',}}>
        {'￥' + (cell.getValue() / 100).toFixed(2)}
      </span>
        ),
    },
    {
        accessorKey: 'origin',
        header: '被邀请ID',
        Cell: ({cell}) =>
            (
                <span style={{color: 'white', fontSize: '16px'}}>
                    {cell.getValue()?.userId|| ''}
                </span>
            ),
    },
    {
        accessorKey: 'remark',
        header: '变化事项',
        Cell: ({cell}) =>
            (
                <span style={{color: 'white', fontSize: '16px'}}>
                    {cell.getValue()}
                </span>
            ),
    },
    {
        accessorKey: 'created',
        header: '时间',
        Cell: ({cell}) => (
            <span style={{color: 'white', fontSize: '16px',}}>
         {formatBeijingTime(cell.getValue())}
      </span>
        ),
    },
];

const AmountHistoryList = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPages, setTotalPages] = React.useState(0);
    const [data, setData] = React.useState([]);
    const itemsPerPage = 20;
    const api = new ApiService();
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    // 请求数据并更新状态
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await api.getUserAmountHistory(itemsPerPage, currentPage);
                setData(result.data.records || []);
                if (currentPage === 1 && (result.data === null || result.data.records.length === 0)) {
                    setTotalPages(0);
                } else {
                    setTotalPages(Math.ceil((result.extends?.total ? result.extends?.total : 1) / itemsPerPage));
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [currentPage, itemsPerPage]);
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <Container>
            <div className={'pb-3'}>
                <div style={{alignItems: 'start', display: 'flex',}}>
                    <button style={{
                        color: '#101217',
                        border: 'none',
                        background: '#02C8E3',
                        borderRadius: '12px',
                        padding: '6px 22px',
                    }} onClick={() => {
                        navigate(-1)
                    }}>
                        <span style={{marginRight: '10px'}}>
                        <FontAwesomeIcon icon={faArrowLeftLong} color={'#101217'} size={'1x'}/>
                      </span>
                        返回
                    </button>
                </div>
                <div style={{background: '#15191E', padding: '24px', borderRadius: '20px',}}>
                    <h5 className={'mb-3'} style={{color: 'white', textAlign: 'start',}}><span>
                    <FontAwesomeIcon icon={faFileLines} color={'#02C8E3'} size={'1x'}/> </span>
                        分成记录
                    </h5>
                    <Table borderless={true} responsive="lg" variant="dark" style={{'minWidth': '700px'}}>
                        <thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th key={header.id}>
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                    </th>
                                ))}
                            </tr>
                        ))}
                        </thead>
                        <tbody>
                        {table.getRowModel().rows.map(row => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map(cell => (
                                    <td key={cell.id}>
                                        {flexRender(cell.column.columnDef.Cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    <Pagination className={'mt-3 mb-3 d-flex  justify-content-center justify-content-lg-end'}>
                        <Pagination.First
                            onClick={() => handlePageChange(1)}
                            disabled={currentPage === 1}/>
                        <Pagination.Prev
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {totalPages <= 4
                            ? Array.from({length: totalPages}, (_, index) => (
                                <Pagination.Item
                                    key={index + 1}
                                    active={index + 1 === currentPage}
                                    onClick={() => handlePageChange(index + 1)}
                                >
                                    {index + 1}
                                </Pagination.Item>
                            ))
                            : [
                                // 第一页
                                <Pagination.Item
                                    key={1}
                                    active={1 === currentPage}
                                    onClick={() => handlePageChange(1)}
                                >
                                    {1}
                                </Pagination.Item>,

                                // 处理第一页和第二页的情况
                                (currentPage === 2 || currentPage === 1) && (
                                    <>
                                        <Pagination.Item
                                            key={2}
                                            active={currentPage === 2}
                                            onClick={() => handlePageChange(2)}
                                        >
                                            {2}
                                        </Pagination.Item>
                                        {totalPages > 3 && <Pagination.Ellipsis key="ellipsis-1" active={false}/>}
                                    </>
                                ),

                                // 处理中间页的情况
                                (currentPage > 2 && currentPage < totalPages - 1) && (
                                    <>
                                        <Pagination.Ellipsis key="ellipsis-1" active={false}/>
                                        <Pagination.Item
                                            key={currentPage}
                                            active
                                            onClick={() => handlePageChange(currentPage)}
                                        >
                                            {currentPage}
                                        </Pagination.Item>
                                        <Pagination.Ellipsis key="ellipsis-2" active={false}/>
                                    </>
                                ),

                                // 处理倒数第二页的情况
                                (currentPage === totalPages || currentPage === totalPages - 1) && (
                                    <>
                                        <Pagination.Ellipsis key="ellipsis-1" active={false}/>
                                        <Pagination.Item
                                            key={totalPages - 1}
                                            active={currentPage === totalPages - 1}
                                            onClick={() => handlePageChange(totalPages - 1)}
                                        >
                                            {totalPages - 1}
                                        </Pagination.Item>
                                    </>
                                ),

                                // 最后一页
                                totalPages > 1 && (
                                    <Pagination.Item
                                        key={totalPages}
                                        active={totalPages === currentPage}
                                        onClick={() => handlePageChange(totalPages)}
                                    >
                                        {totalPages}
                                    </Pagination.Item>
                                )
                            ]
                        }
                        {/*<Pagination.Ellipsis />*/}
                        <Pagination.Next
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                            onClick={() => handlePageChange(totalPages)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </div>
            </div>
        </Container>

    );
};

export default AmountHistoryList;